/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import TextField from '@material-ui/core/TextField';
import {
  checkQuarterValidation,
  compareQtrs,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  DATE_INVALID_FORMAT_ERROR,
  FROM_QTR_REQUIRED,
  TO_QTR_REQUIRED,
  TO_QTR_CANT_BE_LESS_THAN_FROM,
} from '../../../../SharedModules/Errors/constantMessageData';
import { QUARTER_FORMAT_ERROR } from '../../../../SharedModules/AppConstants';
import { autoFormateDate } from '../../../../SharedModules/utilities/utilities';

const textFieldLabelFrom = 'From';
const textFieldLabelTo = 'To';

const CalculatedInterestQuarters = ({
  quarterRange,
  setQuarterRange,
  resetFields,
  onQuarterRangeErrors,
  getManufacturerDetails,
  isDisabled,
  flderror,
}) => {
  const [paidDateRangeFrom, setPaidDateRangeFrom] = useState();
  const [paidDateRangeTo, setPaidDateRangeTo] = useState();
  const [errors, setErrors] = useState();

  useEffect(() => {
    setPaidDateRangeFrom(quarterRange?.paidDateRangeFrom || '');
    setPaidDateRangeTo(quarterRange?.paidDateRangeTo || '');
  }, [quarterRange]);
  React.useEffect(() => {
    let unique = [];
    if (flderror.paidDateRangeFrom)
      unique.push({
        field: 'paidDateRangeFrom',
        errorType: 'required',
        message: FROM_QTR_REQUIRED,
      });
    if (flderror.paidDateRangeFrom)
      unique.push({
        field: 'paidDateRangeTo',
        errorType: 'required',
        message: TO_QTR_REQUIRED,
      });
    setErrors({ quarterRangeErrors: unique });
  }, [flderror]);
  useEffect(() => setErrors(), [resetFields]);

  useEffect(() => {
    if (errors) {
      const err = errors.quarterRangeErrors?.map((item) => item.message);
      onQuarterRangeErrors(err);
    }
  }, [errors]);

  const handleOnChangeEvent = (value, name) => {
    if (value) value = value.toUpperCase();
    setQuarterRange({ ...quarterRange, [name]: value });
  };

  //  on Blur event handler on field level
  const handleOnblurEvent = async (type, value, name, fieldType) => {
    let localErr = [];
    // if (value) value = value.toUpperCase();
    if (name === 'dateField') {
      if (value && !_.isEmpty(value) && !_.isNaN(value)) {
        const indexOf = !_.isEmpty(localErr)
          ? _.findIndex(localErr, {
              field: type,
              errorType: 'required',
            })
          : null;

        if (!_.isNull(indexOf) && indexOf >= 0) {
          localErr.splice(indexOf, 1);
        }
        if (checkQuarterValidation(value)) {
          if (type === 'paidDateRangeFrom') {
            localErr = localErr.filter(
              (item) =>
                item.field !== 'paidDateRangeTo' &&
                item.errorType !== 'required'
            );
            if (quarterRange?.paidDateRangeTo) {
              if (!quarterRange?.paidDateRangeTo?.includes('Q')) {
                localErr.push({
                  field: 'paidDateRangeFrom',
                  errorType: 'invalidFormat',
                  message: DATE_INVALID_FORMAT_ERROR,
                });
              } else if (compareQtrs(value, quarterRange.paidDateRangeTo)) {
                localErr.push({
                  field: 'paidDateRangeTo',
                  errorType: 'invalidFormat',
                  message: TO_QTR_CANT_BE_LESS_THAN_FROM,
                });
              } else {
                localErr = localErr?.filter(
                  (item) =>
                    item.field !== 'paidDateRangeTo' &&
                    item.field !== 'paidDateRangeFrom'
                );
              }
              setQuarterRange({
                ...quarterRange,
                paidDateRangeFrom: value?.toUpperCase(),
              });

              localErr = localErr.filter(
                (item) => item.field !== 'paidDateRangeFrom'
              );
            } else {
              setQuarterRange({
                ...quarterRange,
                paidDateRangeFrom: value?.toUpperCase(),
                paidDateRangeTo: value?.toUpperCase(),
              });

              localErr = localErr.filter(
                (item) => item.field !== 'paidDateRangeFrom'
              );
            }
          }
          if (type === 'paidDateRangeTo') {
            if (quarterRange?.paidDateRangeFrom) {
              if (!quarterRange?.paidDateRangeFrom?.includes('Q')) {
                localErr.push({
                  field: 'paidDateRangeTo',
                  errorType: 'invalidFormat',
                  message: DATE_INVALID_FORMAT_ERROR,
                });
              } else if (compareQtrs(quarterRange.paidDateRangeFrom, value)) {
                localErr.push({
                  field: 'paidDateRangeTo',
                  errorType: 'invalidFormat',
                  message: TO_QTR_CANT_BE_LESS_THAN_FROM,
                });
              } else {
                localErr = localErr?.filter(
                  (item) =>
                    item.field !== 'paidDateRangeTo' &&
                    item.field !== 'paidDateRangeFrom'
                );
              }
            }
            setQuarterRange({
              ...quarterRange,
              paidDateRangeTo: value.toUpperCase(),
            });
          }
          const indexOf = !_.isEmpty(localErr)
            ? _.findIndex(localErr, {
                field: type,
                errorType: 'required',
              })
            : null;

          if (!_.isNull(indexOf) && indexOf >= 0) {
            localErr.splice(indexOf, 1);
          }
        } else {
          localErr.push({
            field: type,
            errorType: 'invalidFormat',
            message: QUARTER_FORMAT_ERROR,
          });
        }
      } else {
        localErr = localErr.filter((item) => item.field !== type);
        localErr.push({
          field: type,
          errorType: 'required',
          message:
            fieldType === 'fromField' ? FROM_QTR_REQUIRED : TO_QTR_REQUIRED,
        });
      }
    }
    const unique = [...new Set(localErr)];

    if (localErr.length == 0) {
      await getManufacturerDetails();
    }
    setErrors({ quarterRangeErrors: unique });
  };

  return (
    <>
      <div className="col-3 mui-custom-form p-0">
        <div className="form-wrapper p-0">
          {}
          <TextField
            data-testid="paid-date-range-from"
            id="paid-date-range-from-id"
            label={textFieldLabelFrom}
            fullWidth
            disabled={isDisabled}
            required
            inputProps={{ maxLength: 6 }}
            InputLabelProps={{
              shrink: true,
            }}
            value={paidDateRangeFrom}
            className={
              errors?.quarterRangeErrors?.length > 0
                ? _.map(errors?.quarterRangeErrors, (l) =>
                    l.field === 'paidDateRangeFrom' ? 'mandate-fields' : null
                  )
                : null
            }
            onBlur={(e) =>
              handleOnblurEvent(
                'paidDateRangeFrom',
                autoFormateDate(e.target.value?.toUpperCase()),
                'dateField',
                'fromField'
              )
            }
            onChange={(e) => {
              handleOnChangeEvent(e.target.value, 'paidDateRangeFrom');
            }}
            error={
              errors?.quarterRangeErrors?.length > 0 &&
              errors?.quarterRangeErrors?.filter((x) => {
                return x.field === 'paidDateRangeFrom';
              }).length > 0
                ? [
                    ...new Set(
                      errors?.quarterRangeErrors
                        ?.filter((x) => {
                          return x.field === 'paidDateRangeFrom';
                        })
                        .map((item) => {
                          return item.message;
                        })
                    ),
                  ]
                : false
            }
            helperText={
              errors?.quarterRangeErrors?.length > 0
                ? [
                    ...new Set(
                      errors?.quarterRangeErrors
                        ?.filter((x) => {
                          return x.field === 'paidDateRangeFrom';
                        })
                        .map((item) => {
                          return item.message;
                        })
                    ),
                  ]
                : null
            }
          />
          {}
        </div>
      </div>
      <div className="col-3 mui-custom-form p-0">
        <div className="form-wrapper p-0">
          {}
          <TextField
            data-testid="paid-Date-Range-To"
            id="paid-Date-Range-To-id"
            label={textFieldLabelTo}
            fullWidth
            disabled={isDisabled}
            required
            inputProps={{ maxLength: 6 }}
            InputLabelProps={{
              shrink: true,
            }}
            className={
              errors?.quarterRangeErrors?.length > 0
                ? _.map(errors?.quarterRangeErrors, (l) =>
                    l.field === 'paidDateRangeTo' ? 'mandate-fields' : null
                  )
                : null
            }
            value={paidDateRangeTo}
            onChange={(e) => {
              handleOnChangeEvent(e.target.value, 'paidDateRangeTo');
            }}
            onBlur={(e) =>
              handleOnblurEvent(
                'paidDateRangeTo',
                autoFormateDate(e.target.value),
                'dateField',
                'toField'
              )
            }
            error={
              errors?.quarterRangeErrors?.length > 0 &&
              errors?.quarterRangeErrors?.filter((x) => {
                return x.field === 'paidDateRangeTo';
              }).length > 0
                ? [
                    ...new Set(
                      errors?.quarterRangeErrors
                        ?.filter((x) => {
                          return x.field === 'paidDateRangeTo';
                        })
                        .map((item) => {
                          return item.message;
                        })
                    ),
                  ]
                : false
            }
            helperText={
              errors?.quarterRangeErrors?.length > 0
                ? [
                    ...new Set(
                      errors?.quarterRangeErrors
                        ?.filter((x) => {
                          return x.field === 'paidDateRangeTo';
                        })
                        .map((item) => {
                          return item.message;
                        })
                    ),
                  ]
                : null
            }
          />
          {}
        </div>
      </div>
    </>
  );
};

export default CalculatedInterestQuarters;
